<template>
  <div class="dovemed-container">
    <div class="dovemed-wrapper text-center signup-page">
      <div class="signup-container" :style="{ 'max-width': '900px' }">
        <h2 class="hyper-link mb-3">
          Welcome to {{ currentCircle.condition_type }}{{ !currentCircle.condition_type.toLowerCase().includes('circle') ? ' Circle': '' }}
        </h2>
        <p>
          To access MyCircles as an Administrator, you need to have a claimed
          {{ type }} profile on DoveMed.
        </p>
        <div class="row">
          <div class="mt-3 col-md-5 col-sm-12">
            <div class="desc-card mb-3">
              <h3>Not sure if i claimed the profile</h3>
            </div>
          </div>
          <div class="col-md-7 col-sm-12">
            <div class="mt-3">
              <div
                @click="handleSelect('login')"
                class="input-placeholder cp mt-3"
                :style="{ border: '1px solid ' + getPrimaryColor() }"
              >
                I have a claimed profile
              </div>
              <div
                @click="handleSelect('claim')"
                class="input-placeholder cp mt-3"
                :style="{ border: '1px solid ' + getPrimaryColor() }"
              >
                I want to claim my profile
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WelcomeAdmin",
  data() {
    return {
      type: undefined
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    let type = this.$router.currentRoute.query.role.split(" ")[0].toLowerCase();
    if (type == "non") {
      type = "nfp";
    }
    this.type = type;
  },
  methods: {
    handleSelect(type) {
      if (type === "claim") {
        const URL = `${process.env.SSO_BASE_URL}/ratings/physicians/`;
        window.open(URL, "_blank");
      } else {
        this.logout();
        this.$router.push({ name: "AllCircles" });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.desc-card {
  padding: 24px 30px;
  border-radius: 2px;
  background-color: #f3f7fd;
  text-align: left;
  h3 {
    color: #333333;
    font-family: Lato;
    font-size: 21px;
    font-weight: bold;
    padding-bottom: 16px;
    line-height: 1;
    margin: 0;
  }
  p {
    color: #333333;
    font-family: Lato;
    font-size: 16px;
    margin: 0;
  }
}
.input-placeholder {
  transition: all 250ms ease-in;
  &:hover {
    transform: scale(1.005);
    background: #f8f8f8;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Signup/UserProfile/WelcomeAdmin.vue